
import { defineComponent } from "vue";
export default defineComponent({
    name: "chatBotStatistic",
    setup() {
        return {
        }
    },
    methods: {

    },
});
